import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* getHall(action) {
    try {
        const request = yield call(() =>
            hallsAPI.getHall({ hallId: action.payload.hallId })
        );

        let data = { ...request.data };
        if (data.hasOwnProperty("allow_license_renew")) {
            data.allow_license_renew =
                typeof data.allow_license_renew == "boolean"
                    ? data.allow_license_renew
                    : Boolean(data.allow_license_renew);
        }

        yield put({
            type: HallsActionTypes.GET_HALL_SUCCESS,
            payload: {
                hall: data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting hall.");
        yield put({
            type: HallsActionTypes.GET_HALL_FAIL,
            message: e.message
        });
    }
}

export function* getHallWatcher() {
    yield takeLatest(HallsActionTypes.GET_HALL, getHall);
}
